/* globals moment */

// TODO pchen: make eventTracker a class so we can change init to a constructor and appboy a property
let appboy;

function init(config, _appboy) {
  appboy = _appboy;
  appboy.initialize(config.braze.apiKey, {
    // 1 hour to match SSO token expiration
    sessionTimeoutInSeconds: 3600,
    minimumIntervalBetweenTriggerActionsInSeconds: config.braze.minimumIntervalBetweenTriggerActionsInSeconds,
    enableLogging: config.braze.enableLogging
  });
  appboy.openSession();
  // appboy.display.automaticallyShowNewInAppMessages();
}

const EVENTS = {
  // events that should be unpacked instead of being sent to braze (prefix with _)
  LOGIN: "_login",
  SIGNUP: "_signup",
  CANCEL_ACCOUNT: "_cancel_account",
  UPDATE_BILLING: "_update_billing",
  WEATHER_LAYER: "_weather_layer",
  UPDATE_SUB_LEVEL: "_update_sub_level",
  APP_CHANGE: "_app_change",
  RT_OPTIONS: "_rt_options",
  LEAST_DATA_VERSION: "_least_data_version",
  LOGOUT: "_logout"
  // TODO pchen: add constants for event names sent to braze
}

const ATTRS = {}

const DATES = {}

function setAttr(name, value) {
  appboy.getUser().setCustomUserAttribute(name, value);
}

function delAttr(name) {
  appboy.getUser().setCustomUserAttribute(name, null);
}

function track(event, args = {}) {
  switch (event) {
    case EVENTS.LOGIN:
      trackLogin(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.SIGNUP:
      trackSignup(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.CANCEL_ACCOUNT:
      trackCancelAcc(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.UPDATE_BILLING:
      trackUpdateBilling(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.UPDATE_SUB_LEVEL:
      trackUpdateSubLevel(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.WEATHER_LAYER:
      trackWeatherLayer(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.APP_CHANGE:
      trackAppChange(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.RT_OPTIONS:
      trackRouteOptions(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.LEAST_DATA_VERSION:
      trackLeastDataversionUsedByCustomer(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.LOGOUT:
      trackLogout(args);
      break;
    default:
      // _ prefix means event should be unpacked above instead of being sent to braze
      if (event && event[0] !== "_") {
        appboy.logCustomEvent(event);
        appboy.requestImmediateDataFlush();
      } else {
        console.error("unimplemented event: " + event);
      }
  }
}

function uniqueId({ userName, account }) {
  // TODO: use uuids instead
  return `${userName}@${account}`;
}

function trackLogin({ user }) {
  if (user.firstName && user.lastName && user.userName) {
    // braze analytics for login
    appboy.changeUser(uniqueId(user));
    appboy.getUser().setFirstName(user.firstName);
    appboy.getUser().setLastName(user.lastName);
    // username should be an email address
    appboy.getUser().setEmail(user.userName);
    appboy.getUser().setCustomUserAttribute("Last Used Version", "V1");
    const featureLevel = (user.accountType === "Trial") ? "Trial" : user.subscriptionLevel;
    appboy.getUser().setCustomUserAttribute("Subscription Level", featureLevel);
    appboy.getUser().setCustomUserAttribute("Trial End", user.expirationDate);
    const remainingRoutes = (user.remainingRoutes < 0) ? null : user.remainingRoutes;
    appboy.getUser().setCustomUserAttribute("Routes Remaining (Trial User)", remainingRoutes);
    const data = window.localStorage.getItem("user_authToken");
    if (user && user.authToken !== data) {
      appboy.logCustomEvent("Login Legacy");
      window.localStorage.setItem("user_authToken", user.authToken);
    }
    appboy.subscribeToInAppMessage((inAppMessage) => {
      appboy.display.showInAppMessage(inAppMessage);
    });
  }
}

function trackSignup({ signup }) {
  // braze analytics for sign up
  appboy.changeUser(uniqueId({ userName: signup.userName, account: signup.companyName }));
  appboy.getUser().setFirstName(signup.firstName);
  appboy.getUser().setLastName(signup.lastName);
  // username should be an email address
  appboy.getUser().setEmail(signup.userName);
  const featureLevel = signup.featureLevel;
  if (featureLevel === "Trial") {
    appboy.logCustomEvent("Trial Activation");
    appboy.getUser().setCustomUserAttribute("Trial Start", new Date());
    // TODO: get these values from signup response (which is currently nothing) if possible
    //   instead of hardcoding default values of 7 days and 35 routes
    appboy.getUser().setCustomUserAttribute("Trial End", moment().add(7, "d").toDate());
    appboy.getUser().setCustomUserAttribute("Routes Remaining (Trial User)", 35);
  } else if (featureLevel === "Standard") {
    appboy.logCustomEvent("Standard Sub Purchase");
    appboy.getUser().setCustomUserAttribute("Standard Subscription Start", new Date());
  } else if (featureLevel === "Premium") {
    appboy.logCustomEvent("Premium Sub Purchase");
    appboy.getUser().setCustomUserAttribute("Premium Subscription Start", new Date());
  }
  appboy.getUser().setCustomUserAttribute("Subscription Level", featureLevel);
  appboy.getUser().setHomeCity(`${signup.city}, ${signup.state}`);
  appboy.getUser().setCustomUserAttribute("User City", signup.city);
  appboy.getUser().setCustomUserAttribute("User State", signup.state);
  // switch back to BrazeDummyUser because user still has to sign in after signing up
  trackLogout();
}

function trackCancelAcc({ featureLevel }) {
  // braze analytics for canceling account
  if (featureLevel === "Trial") {
    appboy.logCustomEvent("Trial Cancelled");
  } else if (featureLevel === "Standard") {
    appboy.logCustomEvent("Standard Sub Cancelled");
  } else if (featureLevel === "Premium") {
    appboy.logCustomEvent("Premium Sub Cancelled");
  }
  appboy.getUser().setCustomUserAttribute("Deactivation Date", new Date());
}

function trackUpdateBilling({ ogCity, newCity, ogState, newState }) {
  // braze analytics for updating account billing features
  if ((ogCity !== newCity) || (ogState !== newState)) {
    if (ogCity !== newCity) {
      appboy.getUser().setCustomUserAttribute("User City", newCity);
    }
    if (ogState !== newState) {
      appboy.getUser().setCustomUserAttribute("User State", newState);
    }
    appboy.getUser().setHomeCity(`${newCity}, ${newState}`);
  }
}

function trackUpdateSubLevel({ ogFL, newFL }) {
  // braze analytics for updating account feature level
  // pchen: some checks in the if conditions might be redundant based on where this function is called
  if (ogFL === "Trial") {
    appboy.logCustomEvent(`${newFL} Sub Purchase`);
  } else if (ogFL === "Standard" && newFL === "Premium") {
    appboy.logCustomEvent("Standard to Premium Upgrade");
  } else if (ogFL === "Premium" && newFL === "Standard") {
    appboy.logCustomEvent("Premium to Standard Downgrade");
  }
  appboy.getUser().setCustomUserAttribute("Subscription Level", newFL);
  if (newFL !== "Trial") {
    appboy.getUser().setCustomUserAttribute(`${newFL} Subscription Start`, new Date());
  }
}

function trackWeatherLayer({ mapService }) {
  // braze analytics for toggling a weather layer on or off
  const alerts =  mapService.isWeatherAlertsVisible();
  const cloud =  mapService.isWeatherCloudVisible();
  const radar = mapService.isWeatherRadarVisible();
  const rs = mapService.isRoadSurfaceVisible();
  const weatherUsage = [alerts, cloud, radar, rs];
  // translate weather usage into array of strings to log into appboy custom user attribute
  const weatherUsageReadable = ["Weather Alerts", "Cloud Layer", "Radar Layer", "Road Conditions Layer"]
    .filter((s, i) => weatherUsage[i]);
  if (weatherUsageReadable.length > 0) {
    appboy.logCustomEvent("Show Weather Layers");
    appboy.getUser().setCustomUserAttribute("Weather", weatherUsageReadable);
  } else {
    appboy.logCustomEvent("Hide Weather Layers");
    appboy.getUser().setCustomUserAttribute("Weather", null);
  }
}

function trackAppChange({ product }) {
  // braze diagnostics for cloud menu
  let appboyEventName = "Clicks to ";
  switch (product.productTitle) {
    case "Content Tools":
    case "MapSure":
      appboyEventName += product.productTitle;
      break;
    default:
      appboyEventName = null;
  }
  if (appboyEventName) {
    appboy.logCustomEvent(appboyEventName);
  }
}

function trackRouteOptions({ options }) {
  // braze analytics for route options
  if (options.useTraffic) {
    appboy.logCustomEvent("Use Traffic");
    appboy.getUser().setCustomUserAttribute("Traffic", true);
  } else {
    appboy.getUser().setCustomUserAttribute("Traffic", null);
  }
  if (options.afSetIDs && options.afSetIDs.length > 0) {
    appboy.logCustomEvent("Route Modifiers");
  }
  appboy.logCustomEvent("Changed Legacy Routing Options");
}

function trackLeastDataversionUsedByCustomer({ version }) {
  appboy.getUser().setCustomUserAttribute("Minimum Data Version Used", version);
}

function trackLogout() {
  // braze analytics for logout
  // dummy user so that logging out and back in will update campaigns from braze
  // shouldn't be used for anything else, and should change to a real user before any data is logged
  appboy.changeUser("BrazeDummyUser");
}


module.exports = { init, EVENTS, setAttr, delAttr, track };



// WEBPACK FOOTER //
// ./app/alk-engagement/eventTracker.js